import axiosInstance from "../AxiosInstance";

export const retrieveSubscriptionManage = (props) => {
    props.setIsLoading(true)
    axiosInstance.get('/subscriptions/manage').then((response) => {
        console.log('Subscription Manage', response)
        props.setSubscriptionData(response.data.data || response.data)
        props.setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        props.setIsLoading(false)
        if (error.response && error.response.status === 422) {
            console.log('Validation Errors:', error.response.data.message);
        } else {
            console.error('Error:', error);
        }
    })
}

export const retrieveAccountStatus = (props) => {
    axiosInstance.get('/subscriptions/account-status').then((response) => {
        console.log('Account Status', response)
        props.setAccountStatus(response.data.data || response.data)
    }).catch((error) => {
        console.error('Account Status Error:', error)
    })
}

export const disableRenewal = (props) => {
    props.setIsLoading(true)
    axiosInstance.post(`/subscriptions/${props.subscriptionId}/disable-renewal`).then((response) => {
        console.log('Disable Renewal', response)
        props.setMessage('Rinnovo automatico disattivato')
        props.setUpdate(prev => !prev)
        props.setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        props.setErrors(error.response?.data?.message || 'Errore durante la disattivazione del rinnovo')
        props.setIsLoading(false)
    })
}

export const enableRenewal = (props) => {
    props.setIsLoading(true)
    axiosInstance.post(`/subscriptions/${props.subscriptionId}/enable-renewal`).then((response) => {
        console.log('Enable Renewal', response)
        props.setMessage('Rinnovo automatico riattivato')
        props.setUpdate(prev => !prev)
        props.setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        props.setErrors(error.response?.data?.message || 'Errore durante la riattivazione del rinnovo')
        props.setIsLoading(false)
    })
}

export const previewChangePlan = (props) => {
    props.setIsLoading(true)
    axiosInstance.post(`/subscriptions/${props.subscriptionId}/change-plan`, {
        plan_code: props.planCode
    }).then((response) => {
        console.log('Preview Change Plan', response)
        props.setPreviewData(response.data.data || response.data)
        props.setShowPreview(true)
        props.setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        props.setErrors(error.response?.data?.message || 'Errore durante il preview del cambio piano')
        props.setIsLoading(false)
    })
}

export const confirmChangePlan = (props) => {
    props.setIsLoading(true)
    axiosInstance.post(`/subscriptions/${props.subscriptionId}/confirm-change-plan`, {
        plan_code: props.planCode
    }).then((response) => {
        console.log('Confirm Change Plan', response)
        const data = response.data.data || response.data
        if (data.approve_url) {
            window.location.href = data.approve_url
        } else {
            props.setMessage('Piano aggiornato con successo')
            props.setUpdate(prev => !prev)
        }
        props.setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        props.setErrors(error.response?.data?.message || 'Errore durante il cambio piano')
        props.setIsLoading(false)
    })
}

export const updatePaymentMethod = (props) => {
    props.setIsLoading(true)
    axiosInstance.post(`/subscriptions/${props.subscriptionId}/update-payment-method`).then((response) => {
        console.log('Update Payment Method', response)
        const data = response.data.data || response.data
        if (data.approve_url) {
            window.location.href = data.approve_url
        }
        props.setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        props.setErrors(error.response?.data?.message || 'Errore durante l\'aggiornamento del metodo di pagamento')
        props.setIsLoading(false)
    })
}

export const cancelSubscription = (props) => {
    props.setIsLoading(true)
    axiosInstance.post(`/subscriptions/${props.subscriptionId}/cancel`, {
        reason: props.reason || ''
    }).then((response) => {
        console.log('Cancel Subscription', response)
        props.setMessage('Abbonamento cancellato')
        props.setUpdate(prev => !prev)
        props.setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        props.setErrors(error.response?.data?.message || 'Errore durante la cancellazione')
        props.setIsLoading(false)
    })
}
